import ComingSoon from '../general/comingSoon/ComingSoon';

export function OilFinder() {
    return <ComingSoon />;
}
